import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePageChoiceMutationVariables = Types.Exact<{
  input: Types.CreatePageChoiceInput;
}>;


export type CreatePageChoiceMutation = { __typename?: 'RootMutationType', createPageChoice?: { __typename?: 'PageChoiceResult', pageChoice?: { __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number, middleInteraction: { __typename?: 'MiddleInteraction', id: string, type: Types.MiddleInteractionType, question?: string | null, embed?: { __typename?: 'Embed', id: string, linkUrl: string, oembedResult?: any | null, status: Types.EmbedStatus, reason?: Types.EmbedFailureReason | null } | null }, nextPage?: { __typename?: 'InitiationItem', id: string, title: string, type: Types.InitiationItemType, order: number } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const CreatePageChoiceDocument = gql`
    mutation createPageChoice($input: CreatePageChoiceInput!) {
  createPageChoice(input: $input) {
    pageChoice {
      id
      type
      hasNext
      text
      value
      order
      middleInteraction {
        id
        type
        question
        embed {
          id
          linkUrl
          oembedResult
          status
          reason
        }
      }
      nextPage {
        id
        title
        type
        order
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type CreatePageChoiceMutationFn = Apollo.MutationFunction<CreatePageChoiceMutation, CreatePageChoiceMutationVariables>;

/**
 * __useCreatePageChoiceMutation__
 *
 * To run a mutation, you first call `useCreatePageChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageChoiceMutation, { data, loading, error }] = useCreatePageChoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageChoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageChoiceMutation, CreatePageChoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageChoiceMutation, CreatePageChoiceMutationVariables>(CreatePageChoiceDocument, options);
      }
export type CreatePageChoiceMutationHookResult = ReturnType<typeof useCreatePageChoiceMutation>;
export type CreatePageChoiceMutationResult = Apollo.MutationResult<CreatePageChoiceMutation>;
export type CreatePageChoiceMutationOptions = Apollo.BaseMutationOptions<CreatePageChoiceMutation, CreatePageChoiceMutationVariables>;